export default __webpack_public_path__ + "static/006952c054085c11e01dbc38a679bce6.jpg";